import React, { Fragment } from 'react';
import { Link } from 'react-router';
import cn from 'classnames';
import './Bars.scss';

import InformationalPopover from 'chameleon/ui-stack/ui/popovers/informational-popover';

const Bars = ({
  label,
  barsData,
  comparisonStyleClass,
  percentStyleClass,
  doubleBar = false,
  hasComparisonPercentages = false,
}) =>
  barsData && (
    <section
      className={cn(
        'bar-container',
        { 'no-label': !label },
        { double: doubleBar },
        { comparison: hasComparisonPercentages },
      )}
    >
      {label && <h5>{label}</h5>}
      <div>
        {barsData.map(
          ({
            percent,
            comparisonPercentage,
            title,
            key,
            link,
            target = '_blank',
            showPopover,
            popoverContent,
          }) => (
            <div key={key || title} className="bar-row">
              <span className="bar-row-label">
                {showPopover ? (
                  <InformationalPopover
                    icon={title}
                    message={
                      popoverContent || (
                        <p>No related Learning Objectives found.</p>
                      )
                    }
                  />
                ) : link ? (
                  <Link to={link} target={target}>
                    {title}
                  </Link>
                ) : (
                  title
                )}
              </span>
              <div className="bar-row-container">
                {doubleBar ? (
                  <Fragment>
                    <div
                      className={`bar-row-content ${percentStyleClass} ${percent <= 80 ? 'low' : 'high'}`}
                      style={{ width: `${percent}%` }}
                    />
                    <span>{percent}%</span>
                  </Fragment>
                ) : (
                  <Fragment>
                    <div
                      className={`bar-row-content ${percentStyleClass} ${percent <= 80 ? 'low' : 'high'}`}
                      style={{ width: `${percent}%` }}
                    >
                      <span>{percent}%</span>
                    </div>
                    {comparisonPercentage !== undefined && (
                      <div
                        className={`bar-row-content-comparison ${comparisonStyleClass}`}
                        style={{
                          marginLeft: `calc(${comparisonPercentage}% - 2.1rem)`,
                        }}
                      >
                        <span>{comparisonPercentage}%</span>
                      </div>
                    )}
                  </Fragment>
                )}
              </div>
              {comparisonPercentage !== undefined && doubleBar && (
                <div className="bar-row-container">
                  <div
                    className={`bar-row-content ${comparisonStyleClass} ${percent <= 80 ? 'low' : 'high'}`}
                    style={{ width: `${comparisonPercentage}%` }}
                  />
                  <span>{comparisonPercentage}%</span>
                </div>
              )}
            </div>
          ),
        )}
      </div>
    </section>
  );

export default Bars;
